import React, { forwardRef } from "react";
import { Modal } from "@jobber/components";
import { Button } from "@jobber/components/Button";

type Props = {
}

type ConfirmDialogConfig = {
  title: string
  message?: string
  okButtonText?: string
  cancelButtonText?: string
}

type RefFields = {
  open: (config: ConfirmDialogConfig) => Promise<boolean>
}

const ConfirmationDialog = forwardRef((props: Props, ref: React.Ref<RefFields>) => {
  const [openModal, setOpenModal] = React.useState<boolean>(false)
  const [resolvePromise, setResolvePromise] = React.useState<(val:boolean) => void>()
  const [config, setConfig] = React.useState<ConfirmDialogConfig>({
    title: 'Confirmation',
    message: 'Are you sure?',
    okButtonText: 'Yes',
    cancelButtonText: 'No'
  })

  const openDialog = (_config: ConfirmDialogConfig) => {
    setConfig({
      ...config,
      ..._config
    })
    return new Promise<boolean>((resolve) => {
      setOpenModal(true)
      setResolvePromise(() => resolve)
    })
  }

  React.useImperativeHandle(ref, () => ({
    open: openDialog
  }))

  const onOkButtonClick = () => {
    setOpenModal(false)
    resolvePromise && resolvePromise(true)
  }
  const onCancelButtonClick = () => {
    setOpenModal(false)
    resolvePromise && resolvePromise(false)
  }

  return (
    <Modal title={config.title} open={openModal} onRequestClose={onCancelButtonClick}>
      <div style={{padding: '10px 20px', paddingTop: 0, display: 'flex', flexDirection: 'column', gap: '10px'}}>
        <p>{config.message}</p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'end' }}>
          <Button
            label={config.okButtonText || ''}
            onClick={onOkButtonClick}
          />
          <Button
            label={config.cancelButtonText || ''}
            type={'secondary'}
            onClick={onCancelButtonClick}
          />
        </div>
      </div>
    </Modal>
  )
})

export default ConfirmationDialog

export type { RefFields, ConfirmDialogConfig }
